const formatStringNumberToNumber = (value) => {
  if (typeof value === "string") {
    const numberValue = Number(value.replace(",", "."));
    return isNaN(numberValue) ? null : numberValue;
  }
  return value;
};

export default formatStringNumberToNumber;
